import {
  BackendSmartAccount,
  BackendTransaction,
  OrgAssetTransfer,
  OrgSmartAccount,
  OrgTransaction,
} from '~/types'

export function useMissingSignatures(
  transaction: BackendTransaction | OrgTransaction | OrgAssetTransfer,
  smartAccount: BackendSmartAccount | OrgSmartAccount | undefined,
) {
  if (!smartAccount) return 0

  if (!('signers' in transaction)) return 0

  return (
    smartAccount.threshold -
    transaction.signers.length -
    transaction.eoaSigners.length
  )
}
